module.exports = __webpack_public_path__ + "img/07.8757dce6.png";